import { render, staticRenderFns } from "./imgC.vue?vue&type=template&id=36639c8a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36639c8a')) {
      api.createRecord('36639c8a', component.options)
    } else {
      api.reload('36639c8a', component.options)
    }
    module.hot.accept("./imgC.vue?vue&type=template&id=36639c8a", function () {
      api.rerender('36639c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgC.vue"
export default component.exports